import { Platform } from "react-native";
import { ThotType } from "../models/Thot.type";

type ThotRouteParamsInput = {
  thot?: ThotType;
  thotId?: string;
  entryId?: string;
  playLeafId?: string;
  unchanged?: boolean;
  backToHome?: boolean;
};

export const getThotId = (thot?: string | ThotType): string | undefined => {
  if (!thot) return undefined;
  return typeof thot === "string" ? thot : thot._id;
};

export const buildThotRouteParams = (
  thot: ThotType,
  entry?: ThotType | string,
  playLeafOrUnchanged?: ThotType | string | boolean,
  unchanged?: boolean,
  backToHome?: boolean
): ThotRouteParamsInput => {
  const thotId = getThotId(thot);
  const entryId = getThotId(entry) || thotId;
  const playLeaf = typeof playLeafOrUnchanged === "boolean" ? undefined : playLeafOrUnchanged;
  const finalUnchanged = typeof playLeafOrUnchanged === "boolean" ? playLeafOrUnchanged : unchanged;
  const playLeafId = getThotId(playLeaf);

  return {
    ...(Platform.OS === "web" ? {} : { thot }),
    thotId,
    entryId,
    ...(playLeafId ? { playLeafId } : {}),
    ...(finalUnchanged ? { unchanged: true } : {}),
    ...(backToHome ? { backToHome: true } : {}),
  };
};

export const getRouteEntryId = (
  params?: ThotRouteParamsInput,
  fallbackThotId?: string
): string | undefined => {
  if (!params) return fallbackThotId;
  return params.entryId || params.thotId || fallbackThotId;
};
